<!-- 
Contents of the PREVIEW tab of the notice template page.
-->
<template>
  <div>
    <our-heading
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="levy-collection-setup"
      user-guide-section="notice-templates"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :notice-type="noticeType" :can-edit="canEdit" path="preview">
      <div class="ma-3">
        <notice-template-preview-panel ref="preview" :levy-collection-id="levyCollectionId" :notice-type="noticeType"/>
      </div>
    </tabs>
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import NoticeTemplatePreviewPanel from "@/components/notice-templates/NoticeTemplatePreviewPanel.vue";
import Tabs from "./Tabs.vue";
import noticeTemplateMixins from "./mixins";

export default {
  name: "NoticeTemplatePreview",
  components: { LevyCollectionNavigator, NoticeTemplatePreviewPanel, Tabs },
  mixins: [noticeTemplateMixins]
};
</script>
